import _ from 'lodash'
import moment from 'moment'
import type { Procedure } from '../../../app-core/lib/procedure/Procedure'
import { getFocusListsForLocation } from '../../src/utils/focusLists'
import { Cust_hasSingleLocation } from '../Cust/Cust.serverPrefs'
import type { Type_ILocationFocusList } from '../Type/Type.hive'

export function Proc_getValidFromFocusLists(procedures: Procedure[], validFocusLists: number[], date: Date) {
    // In single location use cases, all procedures are valid
    if (Cust_hasSingleLocation()) return procedures

    const momentDate = moment(date)

    return procedures
        .filter((procedure) => momentDate.isBetween(procedure.startDate, procedure.endDate))
        .filter((procedure) => _.some(procedure.focusLists, (id) => validFocusLists.includes(id)))
}

export function Proc_getValidForLocation(
    procedures: Procedure[],
    focusListLookup: Type_ILocationFocusList[],
    locationId: number,
    date: Date
) {
    // In single location use cases, all procedures are valid
    if (Cust_hasSingleLocation()) return procedures

    const validFocusLists = getFocusListsForLocation(focusListLookup, locationId).map((fl) => fl.id)

    return Proc_getValidFromFocusLists(procedures, validFocusLists, date)
}
